<script setup lang="ts">
import type { Validation } from '@vuelidate/core';
import { type CourierAddress, courierOption as courOpt } from '../../types/Address';
import { CourierAddressSchema } from '../../constants/formSchemas/AddressesSchema';

const props = defineProps<{ data: CourierAddress, v$: Validation<object>, disabled?: boolean }>();
const emit = defineEmits<{
  (e: 'change', value: string | undefined, field: string): void
}>();

function onChange(value: string | undefined, field: string) {
  emit('change', value, field);
};

function onText(payload: Event) {
  emit('change', (payload.target as any)?.value ?? undefined, 'note');
}
</script>

<template>
  <div class="pd-form-cols-2">
    <FormItem class="md:col-span-2" field="note" :label="$t('addresses.courier')">
      <div class="flex gap-6">
        <div class="align-items-center flex">
          <RadioButton
            :model-value="props.data.courier"
            :input-id="`addr-${courOpt.ekont}`"
            :value="courOpt.ekont"
            :disabled="props.disabled ?? false"
            @click="emit('change', courOpt.ekont, 'courier')"
          />
          <label :for="`addr-${courOpt.ekont}`" class="ml-2">{{ $t(`addresses.${courOpt.ekont}`) }}</label>
        </div>
        <div class="align-items-center flex">
          <RadioButton
            :model-value="props.data.courier"
            :input-id="`addr-${courOpt.speedy}`"
            :value="courOpt.speedy"
            :disabled="props.disabled ?? false"
            @click="emit('change', courOpt.speedy, 'courier')"
          />
          <label :for="`addr-${courOpt.speedy}`" class="ml-2">{{ $t(`addresses.${courOpt.speedy}`) }}</label>
        </div>
      </div>
    </FormItem>

    <FormItem
      v-for="schema in CourierAddressSchema"
      :key="schema.field"
      :model-value="(props.data as any)[schema.field]"
      v-bind="schema"
      :v$="props.v$"
      :disabled="props.disabled ?? false"
      @change="onChange"
    />

    <FormItem class="md:col-span-2" field="note" :label="$t('addresses.note')">
      <Textarea
        id="note"
        :value="props.data.note"
        class="w-full"
        :rows="3"
        :cols="30"
        :disabled="props.disabled ?? false"
        @change="onText"
      />
    </FormItem>
  </div>
</template>

<style scoped></style>
